import { render, staticRenderFns } from "./down.vue?vue&type=template&id=3367503b&scoped=true"
import script from "./down.vue?vue&type=script&lang=js"
export * from "./down.vue?vue&type=script&lang=js"
import style0 from "./down.vue?vue&type=style&index=0&id=3367503b&prod&lang=scss&scoped=true"
import style1 from "./down.vue?vue&type=style&index=1&id=3367503b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3367503b",
  null
  
)

export default component.exports